import '@emersya/mpa-std-lib';

export * from './Basket';
export * from './Product';
export * from './Part';
export * from './Option';
export * from './Component';
export * from './Contact';
export * from './Tax';
export * from './Price';
export * from './Pricing';
export * from './Reference';

import * as _Basket from './';

declare global {
	interface Window {
		Basket : typeof _Basket;
		MPABasket : typeof _Basket;
	}
}
(<Record<string, unknown>> globalThis).Basket = _Basket;
(<Record<string, unknown>> globalThis).MPABasket = _Basket;


// export class Price implements IPrice {
// 	static from(
// 		price : Partial<IPrice> | Partial<IPriceSerialized>,
// 		taxes : Tax[]
// 	) {
// 		if (price.exclTax != null ) {
// 			return (this.fromExclTax(price.exclTax, taxes));
// 		} else if (price.inclTax != null) {
// 			return (this.fromExclTax(price.inclTax, taxes));
// 		} else {
// 			throw MPAAPI.errors.user('exclTax or inclTax should be defined in price!', {
// 				price
// 			});
// 		}
// 	};
// 	static fromMonetizableDescriptor(
// 		desc : IMonetizableDescriptor
// 	) {
// 		const price = desc.price;
// 		const taxes = desc.taxes.map(x => x instanceof Tax ? x : Tax.deserialize(x));
// 		if ('exclTax' in price) {
// 			if (price.exclTax === undefined) {
// 				throw new Error;
// 			}
// 			if (price.exclTax instanceof MPAAPI.math.BigNumber) {
// 				if (
// 					!('inclTax' in price) ||
// 					!(price.inclTax instanceof MPAAPI.math.BigNumber)
// 				) {
// 					throw new Error('');
// 				}
// 				return (new Price(price.exclTax, price.inclTax));
// 			}
// 			return (Price.fromExclTax(price.exclTax, taxes));
// 		}
// 		if (price.inclTax === undefined) {
// 			throw new Error;
// 		}
// 		return (Price.fromExclTax(price.inclTax, taxes));
// 	};
// 	serialize() : IPriceSerialized {
// 		return ({
// 			exclTax : this.exclTax.toNumber(),
// 			inclTax : this.inclTax.toNumber()
// 		});
// 	};
// 	applyTax(tax : Tax) {
// 		if (tax.type === 'percent') {
// 			this.inclTax = this.exclTax.plus(
// 				this.exclTax.multipliedBy(tax.value.dividedBy(100))
// 			);
// 		} else if (tax.type === 'value') {
// 			this.inclTax = this.exclTax.plus(tax.value);
// 		}
// 	};

// 	constructor(
// 		excl : MPAAPI.math.BigNumber,
// 		incl : MPAAPI.math.BigNumber
// 	) {
// 		this.exclTax = excl;
// 		this.inclTax = incl;
// 	};
// };
